import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { HttpCommonService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherKindFormComponent } from "../accvoucherkind-form/accvoucherkind-form.component";

@Component({
  selector: "AccVoucherKInd-list",
  templateUrl: "AccVoucherKInd-list.component.html",
  styleUrls: ["AccVoucherKInd-list.component.scss"],
  providers: [HttpCommonService],
})
export class AccVoucherKindListComponent extends BaseListComponent {
  constructor(private route: ActivatedRoute) {
    super();
    this.inputEditorform = AccVoucherKindFormComponent;
  }
  ngOnInit() {
    this.apiName = "AccVoucherKind";
    this.label = this.translate("ClientApp.BackOffice.ACC.AccVoucherKind.VoucherKind");
    this.areaName = "Accounting";
    this.route.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params) => {
      if (params.apiname) this.apiName = params.apiname;
    });
  }
}
